module.exports = __webpack_public_path__ + "img/Saint-Lucia.f14c16fa.png";